import { render, staticRenderFns } from "./Home5.vue?vue&type=template&id=50c844fe&"
import script from "./Home5.vue?vue&type=script&lang=js&"
export * from "./Home5.vue?vue&type=script&lang=js&"
import style0 from "./Home5.vue?vue&type=style&index=0&id=50c844fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports